import { useEffect, useState, useContext } from "react";
import { API } from "../../../API";
import { ShareAPI } from "../../../API";
import { narrativeActorsUrl } from "../../../utils/narrativeActors";
import { BreakdownsContext } from "./contexts/BreakdownsContext";
import {platformIconsMapping, platformNamesMapping} from '../../../utils/platforms';
import { BreakdownsContainer } from "../../../components/BreakdownsContainer/BreakdownsContainer";
import { LoaderSmall } from "../../../components/LoaderSmall/LoaderSmall";
import { useTranslation } from 'react-i18next';
import styles from '../NarrativePage.module.scss';
import { showRequestError } from '../../../utils/requestError';

export const Platforms = ({narrative, isShare, isClickable=true, title}) => {
  const { t } = useTranslation();
  const [platforms, setPlatforms] = useState(null);

  const {openModal, setPlatformsFilter, setCurrentWidgetName, setModalTitle} = useContext(BreakdownsContext);

  const api = isShare ? ShareAPI : API;
  const getNarrativePlatforms = () => {
    const urlParams = new URLSearchParams();
    urlParams.set('widget_name', `platforms_breakdown`);
    const url = narrativeActorsUrl(narrative.id, 'platforms', urlParams);
    api.fetch('GET', url).then(
      data => setPlatforms(data)
    ).catch(e => showRequestError(e, t('Platforms')))
  }

  useEffect(() => {
    getNarrativePlatforms()
  }, [narrative.id])




  return(
    <BreakdownsContainer
      title={title ? title : 'Platforms'}
      onClick={() => openModal()}
      details={false}
    >
     {platforms 
      ? (platforms.objects?.length > 0
      ? <div className={styles.breakdownsListMain}>
        {platforms.objects.map((platform, index) => {
          return(
            <div key={`platforms_${index}`} className={styles.listItem}>
              <div className={styles.info}>
                <span>{platformIconsMapping[platform?.platform]}</span>
                <span 
                  className={styles.title}
                  onClick={() => {
                    if (isClickable) {
                      setPlatformsFilter({value: platform?.platform, label: platformNamesMapping[platform?.platform]})
                      setCurrentWidgetName('platforms_breakdown')
                      setModalTitle(t(platformNamesMapping[platform?.platform]))
                      openModal()
                    }
                  }}
                  >
                      {platformNamesMapping[platform?.platform]}
                  </span>
              </div>
              <div className={styles.count}>{platform?.count}</div>
            </div>
          )
        })}
      </div> 
      : <div className={styles.noDataBreakdowns}>{t('There is no data to display')}</div>
      ) : (<div className={styles.widdgetLoader}><LoaderSmall /></div>)}

    </BreakdownsContainer>
  )
}